import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import {DateFilterItem, SymbolicDate} from '../common/enums';
import AbstractMap, {connectAbstractMap} from './AbstractMap';

/**
 * Typ nástroje.
 */
const ToolType = {
    GEOLOCATION: 'GEOLOCATION',
    NEW_OBJECT: 'NEW_OBJECT',
};

/**
 * Pozice nástroje.
 */
const ToolPosition = {
    TOP_LEFT: 'TOP_LEFT',
    TOP_RIGHT: 'TOP_RIGHT',
    BOTTOM_LEFT: 'BOTTOM_LEFT',
    BOTTOM_RIGHT: 'BOTTOM_RIGHT',
};

/**
 * Základní nástroj.
 */
const Tool = {
    GEOLOCATION: 'GEOLOCATION',
    NEW_OBJECT: 'NEW_OBJECT',
};

/**
 * Typy události.
 */
const EventType = {
    NEW_OBJECT: 'NEW_OBJECT',
    ACTION: 'ACTION',
    APP_SETTINGS_OPEN: 'APP_SETTINGS_OPEN',
};

/**
 * Typy properties specifické pro Map.
 */
export const mapPropTypes = {
    tools: PropTypes.array,
    contextTools: PropTypes.array,
    featureActions: PropTypes.array,
    reticleVisible: PropTypes.bool,
    nativeMobile: PropTypes.bool,
};

/**
 * Výchozí hodnoty properties specifické pro Map.
 */
export const mapDefaultProps = {
    tools: [],
    contextTools: [],
    featureActions: [],
    reticleVisible: false,
    nativeMobile: false,
};

/**
 * Názvy synchronizovaných properties specifických pro Map.
 */
const mapSyncedProps = [
    'tools',
    'contextTools',
    'featureActions',
    'reticleVisible',
];

/**
 * Mapa s pomocnými nástroji.
 */
class Map extends AbstractMap {

    static ToolType = ToolType;
    static ToolPosition = ToolPosition;
    static Tool = Tool;
    static EventType = EventType;
    static SymbolicDate = SymbolicDate;
    static DateFilterItem = DateFilterItem;

    static propTypes = {
        ...AbstractMap.propTypes,
        ...mapPropTypes
    };

    static defaultProps = {
        ...AbstractMap.defaultProps,
        ...mapDefaultProps
    };

    static initialSyncedProps = [
        ...AbstractMap.initialSyncedProps,
        ...mapSyncedProps,
    ];

    static syncedProps = [
        ...AbstractMap.syncedProps,
        ...mapSyncedProps,
    ];

    getInitialSyncedProps() {
        return Map.initialSyncedProps;
    }

    getSyncedProps() {
        return Map.syncedProps;
    }

    render() {
        const {
            className: customClassName,
            tools,
            contextTools,
            featureActions,
            reticleVisible,
            nativeMobile,
            ...otherProps
        } = this.props;

        const src = this.getFrameSrc(nativeMobile ? 'embed-native-mobile-map' : 'embed-map');
        const className = classNames('mapio-feature-editor', customClassName);

        return this.renderFrame({src, className, ...otherProps})
    }
}

export default connectAbstractMap(Map);
